export const basePath = '/key-topics'

export const routes = {
  root: basePath,
}
